import root from "./_root.js";
var Symbol = root.Symbol;
export default Symbol;
